import React, { Component } from 'react'
import { API_URL } from '../Constants';
export class Time extends Component {
  render() {

    const totalSeconds = this.props.seconds;
    const {isCenter} = this.props
    const seconds = totalSeconds % 60;
    const minutes =  (totalSeconds-seconds) / 60;
    
    return (
      <div className={`h1 test-time ${isCenter?'text-center':'text-end'} px-3 py-2 mb-0`}>{String(minutes).padStart(2,'0')}:{String(seconds).padStart(2,'0')}</div>
    )
  }
}

export class SectionBase extends Component{
  

  async componentDidMount() {

    const { token, onLogout } = this.props;

      fetch(`${API_URL}/api/profile/`, {
          method: 'GET',
          headers: { Authorization: `Token ${token}` } ,
      }).catch(()=>{
        console.log('profile api error');
        
      }).then(resp=>{
        console.log(resp);
        if (resp.status===200){
            this.nextQuestion();
            
        }else{
          onLogout();
        }
        
        return resp.json()})
      .catch((reason)=>{
        onLogout()
        console.error(reason);
        console.error('ERROR:json parse error');
        
      })
      .then(data=>{
        console.log(data);
        this.setState({profile:data[0]})
            
        //TODO: get user info to show on greetings.
      });
    if (this.onKeyUp !== undefined){
      document.addEventListener('keyup', this.onKeyUp)  
    }
  }


  async componentDidUpdate(prevProps) {
    console.log(prevProps);
    console.log(this.props);
    if(prevProps!==undefined &&  this.props.appName!== prevProps.appName)
    {
      this.componentDidMount();
    } 
  }
  
  startTimer(){
    this.timerInterval = setInterval( ()=>{
      
        let {secondsLeft} = this.state;
        if (secondsLeft>0){
          secondsLeft--;
          this.setState({secondsLeft});
        }else{
          console.log(secondsLeft);
          this.onTimeIsUp();
          this.stopTimer();
        }},1000);
  }

  stopTimer(){
    if (this.timerInterval !== undefined){
      clearInterval(this.timerInterval);
    }
  }

  restartTimer(){
    this.stopTimer();
    this.startTimer();
  }
  /**
     * Implementation required
     */
  onTimeIsUp(){ 
      throw new Error('You have to implement the method onTimeIsUp!');
   
  }

    
  componentWillUnmount(){
    document.removeEventListener('keyup', this.onKeyUp);
    this.stopTimer()
  }

    
}


export class DifficultyBadge extends Component {
  render() {
    return (
        <p className='text-end pe-3'><span className="badge badge-pill bg-warning">{['Easy','Medium','Hard'][this.props.difficulty-1]}</span></p>
    )
  }
}


export class NextQuestion extends Component {
  render() {
      return (
          <div className='mt-5 pb-5 d-flex justify-content-between'>
              <div>

              </div>
              <div className='next-question row align-items-center' style={{ maxWidth: '400px', cursor: 'pointer' }} onClick={this.props.nextQuestion}>
                  <div className='col-auto'>
                      Next Question
                  </div>
                  <div className='col-auto'>
                      <div className="chevron right"></div>
                  </div>

              </div>


          </div>
      )
  }
}
